/**
 * Name: All Top Memes component
 * Description: All Trending memes section
 * Author: omeiza@bigcabal.com
 */

// Styles
import "./Top.scss";

import {Link} from "react-router-dom";
import GridListing from '../GridListing';

// Types

const TopAll = () => {
	return (
		<section className="top-all">
			<div className="container">
				<div className="heading-section">
					<div className="heading-title top-heading-select">
						Top Memes
					</div>
					<div className="meme-type-list">
						<ul>
							<li><Link to="/trending-memes" className="active">All</Link></li>
							<li><Link to="/trending-memes">GIFs</Link></li>
							<li><Link to="/trending-memes">Images</Link></li>
						</ul>
					</div>
				</div>
				<GridListing endPoint="/memes" args={{orderBy:'likeCount', order:'desc'}} columns="4" mobileColumns="2" className="dynamic" masonry="true"/>
			</div>
		</section>
	)
}

export default TopAll;